import React, { useEffect, useState } from "react"

import { Grid, Input, Picker, SimpleCollapse, CheckBox, Span, TextArea } from "components"
import { useException, useLoading, useModal } from "hooks"
import { UseSearchByContract } from "pages/GST/PesquisaPorContrato/context"
import { useFormContext } from "react-hook-form"
import { IResponseTypes } from "services/core/genericEntityGST"
import { DadosContratoServices, IGetDadosContratoResponse } from "services/GST/PesquisaPorContrato"
import { SPACING } from "utils"
import format from "utils/format"

import { IForm } from "../types"

interface IDadosContratoProps {
  isFirstGet: boolean
}

export const DadosContratoCollapse: React.FC<IDadosContratoProps> = ({
  isFirstGet
}) => {
  const {
    control
  } = useFormContext<IForm>()
  const { idContratoSelecionado } = UseSearchByContract()
  const { setLoading } = useLoading()
  const { showModal } = useModal()
  const { createCustomException, getException } = useException()

  const [dadosContrato, setDadosContrato] = useState<IGetDadosContratoResponse>()

  const handleGetDadosDoContrato = (idContrato: number) => {
    setLoading('loading')

    DadosContratoServices()
      .getDadosContrato(idContrato)
      .then((response) => {

        if (response?.status !== 200 || response?.data?.tipo === IResponseTypes['alert']) {
          const { tipo, detalhe, mensagem, } = response?.data

          createCustomException({
            detalhe,
            message: detalhe || mensagem || 'Ocorreu um erro ao fazer a requisição',
            tipo: IResponseTypes[tipo]
          })
        }

        setDadosContrato(response?.data?.entity)
        setLoading('idle')
      })
      .catch((e: Error) => {
        const error = getException(e)

        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: error.message,
          txtButtonConfirm: 'OK',
          type: error.tipo || 'error',
        })
      })
  }

  useEffect(() => {
    if (isFirstGet && idContratoSelecionado) {
      handleGetDadosDoContrato(idContratoSelecionado)
    }
  }, [isFirstGet])

  return (
    <SimpleCollapse title="DADOS DO CONTRATO">
      <Grid
        gridCols="1.5fr 1.5fr  2.5fr  2.4fr  2.4fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <Input defaultValue="" value={dadosContrato?.cdContrato} disabled={true} label="Contrato" placeholder="Contrato" />
        <Input defaultValue="" value={format.documento(dadosContrato?.cdDocto)} disabled={true} label="CNPJ" placeholder="CNPJ" />
        <Input defaultValue="" value={dadosContrato?.nmFornecedor} disabled={true} label="Fornecedor" placeholder="Fornecedor" />
        <Input defaultValue="" value={dadosContrato?.nmEmpresa} disabled={true} label="Empresa" placeholder="Empresa" />
        <Input defaultValue="" value={dadosContrato?.nmCentroPlanta} disabled={true} label="Centro" placeholder="Centro" />
      </Grid>
      <Grid
        gridCols="1.5fr 1.5fr  1.2fr 1.2fr  1fr 1fr 2.4fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <Picker
          defaultValue={null}
          label="Início Vigência Contrato"
          value={dadosContrato?.dtVigenciaInicio}
          disabled={true}
        />
        <Picker
          defaultValue={null}
          label="Fim Vigência Contrato"
          value={dadosContrato?.dtVigenciaFim}
          disabled={true}
        />
        <Picker
          defaultValue={null}
          label="Início Vigência Real"
          value={dadosContrato?.dtVigenciaInicioReal}
          disabled={true}
        />
        <Picker
          defaultValue={null}
          label="Início Vigência Real"
          value={dadosContrato?.dtVigenciaFimReal}
          disabled={true}
        />
        <Input
          defaultValue=""
          value={
            dadosContrato?.tipoCre !== 'Sem Preenchimento' && dadosContrato?.tipoCre !== 'N/A' ?
              dadosContrato?.tipoCre : ''
          }
          disabled={true}
          label="CRE"
          placeholder="CRE"
        />
        <Span text="" />
        <CheckBox disabled={true} label="Sócio" />
      </Grid>
      <Grid
        gridCols="6.3fr 2.4fr  2.4fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <TextArea
          count={dadosContrato?.objetoDoContrato?.length || 0}
          label="Objeto do contrato"
          formValue="objetoDoContrato"
          value={dadosContrato?.objetoDoContrato}
          maxLength={1000}
          disabled={true}
        />
        <Input
          defaultValue=""
          value={dadosContrato?.nmContraparte}
          disabled={true}
          label="Contraparte CSN"
          placeholder="Contraparte CSN"
        />
        <Input
          defaultValue=""
          value={dadosContrato?.cdMatriculaContraparte}
          disabled={true}
          label="Matrícula"
          placeholder="Matrícula"
        />
      </Grid>
    </SimpleCollapse>
  )
}